import styles from './Spinner.module.css';

export const Spinner = () => {
  return <span data-testid="spinner" className={styles.loader} />;
};
